// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__bSKtD","badgePending":"Badge_badgePending__dCDo4","badgeSuccess":"Badge_badgeSuccess__+oKsD","badgeError":"Badge_badgeError__dGMZp"};